import { MagicField } from '../../../../Enums/MagicField.enum';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';

export interface InsuranceCompanyCheckboxItem {
	key: string;
	title: string;
}

export function buildInsuranceCompaniesCheckboxScheme(
	items: InsuranceCompanyCheckboxItem[],
	selectedItems: string[],
): ItemScheme[] {
	return items.map(({ key, title }) => {
		return {
			type: MagicField.CHECKBOX,
			key,
			title,
			value: selectedItems.includes(key),
		};
	});
}
